export default __webpack_public_path__ + "static/flightpath-desk-0f5fb359075764fe386e6ab2be602729.png";